import React from 'react';

import { Anchor, Stack, Text } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { digitalConverter } from 'models';

import { ModalTitle } from 'components/modals/ModalTitle';
import cx from 'components/modals/styles.module.scss';

type Props = {
    file: File;
};

const ImageSizeModal = ({ innerProps }: ContextModalProps<Props>) => {
    const { file } = innerProps;
    const fileSizeInMB = digitalConverter.convert({
        value: file.size,
        from: 'B',
        to: 'MB',
    });

    return (
        <Stack gap="xs" p="sm">
            <ModalTitle>Image too large</ModalTitle>
            <Text className={cx.description} ta="center">
                The selected image exceeds the maximum upload size of 5 MB.
                <br />
                Current size: {Math.round(fileSizeInMB.value)} MB.
            </Text>
            <Text className={cx.description} ta="center">
                Please compress the image to reduce its file size.
                <br />
                You can use online tools such as{' '}
                <Anchor href="https://imagecompressor.com/" target="_blank">
                    imagecompressor.com
                </Anchor>
                {' or '}
                <Anchor href="https://squoosh.app/" target="_blank">
                    squoosh.app
                </Anchor>
                .
            </Text>
        </Stack>
    );
};

export { ImageSizeModal };
